// 海コン受注配車入力一覧内の定数

export const 荷主Bindings = ["荷主", "荷主名", "表紙分割ID"]

export const コンテナ情報Bindings = ["コンテナサイズ", "コンテナ軸"]

export const PICKBindings = [
  "PICK積卸先id",
  "PICK積卸先名称",
  "PICK積卸先市区町村",
  "PICK運行部所コード",
]

export const 作業Bindings = [
  "作業積卸先id",
  "作業積卸先名称",
  "作業積卸先市区町村",
  "作業運行部所コード",
]
export const 返却Bindings = [
  "返却積卸先id",
  "返却積卸先名称",
  "返却積卸先市区町村",
  "返却運行部所コード",
]

export const その他Bindings = [
  "その他積卸先id",
  "その他積卸先名称",
  "その他積卸先市区町村",
  "その他運行部所コード",
]

export const 請求Bindings = [
  "荷主請求内訳ID",
  "請求運送料課税区分コード",
  "請求運送料",
  "請求付帯料課税区分コード",
  "請求付帯料",
  "請求高速料税込区分名称",
  "請求高速料",
  "請求合計",
  "計上基準日区分名称",
  "請求備考",
]

export const 支払Bindings = [
  "支払運送料課税区分コード",
  "支払運送料",
  "支払付帯料課税区分コード",
  "支払付帯料",
  "支払高速料税込区分名称",
  "支払高速料",
  "支払合計",
  "支払備考",
]
